import { Component, Vue, Watch } from 'vue-property-decorator'
import { queryTeacherAdminsupervisor } from '@/api'
import HighFilter from '@/components/highFilter/index.vue'
import urlBase from '@/utils/urlBase'

@Component({ name: 'SupervisorList', components: { HighFilter } })
export default class SupervisorList extends Vue {
  private tableData: any = []
  private teacherName: any =''
  private pageType: any = null
  private fileList: any =[]
  private currentPage: any = 1
  private filterData: any =[]
  private filterResult: any = {}
  private totalPage: any = 1
  private totalNum: any = 1
  private tableloading: any = false
  private showHighFilter: any = false
  private modify: any= {
    // url: 'http://192.168.0.33:10069/teacherAdmin/supervisor/import'
    url: urlBase.eduBaseUrl + 'teacherAdmin/supervisor/import'
  }

  created () {
    // 1.主导师 2.Mentor库 3.论文导师库 4.科研助教导师
    this.tableData = []
    this.pageType = this.$route.meta.type
    this.initPageData()
  }

  activated () {
    // 只刷新数据，不改变整体的缓存
    this.initPageData()
  }

  private async initPageData () {
    this.tableloading = true
    const param: any = { page: this.currentPage, name: this.teacherName, limit: 20 }
    if (this.filterResult) {
      param.search = this.filterResult
    }
    const result: any = await queryTeacherAdminsupervisor(param)
    this.filterData = result.search
    const { allPage, currentPage, allNumber, teacherList } = result
    this.tableData = teacherList
    this.totalPage = allPage
    this.totalNum = allNumber
    this.currentPage = currentPage
    this.tableloading = false
  }

  private async onPageChange () {
    this.initPageData()
  }

  // 批量导入
  private async handleModifySuccess (response: any) {
    if (response.error.returnCode === 0) {
      this.$message({
        type: 'success',
        message: '导入成功!'
      })
      this.currentPage = 1
      await this.initPageData()
    } else {
      this.$message({
        type: 'error',
        message: response.error.returnMessage
      })
    }
    const upload: any = this.$refs.upload
    upload.clearFiles()
  }

  private async handleModifyError () {
    this.$message({
      type: 'error',
      message: '导入失败!'
    })
    const upload: any = this.$refs.upload
    upload.clearFiles()
  }

  private downloadTemplate () {
    const url: any = 'https://gecacademy.oss-cn-beijing.aliyuncs.com/owl/teacherExcel/supervisor.xlsx'
    const a: any = document.createElement('a')
    a.href = url //  URL对象
    a.click() // 模拟点击
  }

  // 表格修改/查看详情
  private ediLookDetailRow (row: any, type: any) {
    this.$router.push({ path: 'tutor_detail', query: { type: type, id: row.id, pageType: this.pageType } })
  }

  private addTeacher (type: any) {
    this.$router.push({ path: 'tutor_detail', query: { type: type, pageType: this.pageType } })
  }

  // 查看课表
  async lookRow (row: any) {
    this.$router.push({ path: '/student/schedule', query: { teacherId: row.id, teacherName: row.realName, lookType: '6' } })
  }

  private async onFilterResult (data: any) {
    this.filterResult = data
    this.currentPage = 1
    await this.initPageData()
    this.showHighFilter = false
  }
}
